import React, { useEffect } from 'react';
import ArticleGrid from '../components/home/ArticleGrid.tsx';
import { useApp } from '../context/AppContext.tsx';

export default function BlogCatalog() {
  const { settings } = useApp();
  const articleSec = settings?.sections?.find((s) => s.type === 'articles_blog_grid');
  const pageTitle = articleSec?.title !== undefined && articleSec.title.trim() !== '' ? articleSec.title : 'Artikel & Berita Hukum';

  useEffect(() => {
    const customTab = settings?.pageTabTitles?.blog?.trim();
    if (customTab) {
      document.title = customTab;
    } else {
      const suffix = settings?.pageTabTitles?.titleSuffix !== undefined ? settings.pageTabTitles.titleSuffix : ` | ${settings?.siteName || 'ALY LAW FIRM'}`;
      document.title = `${pageTitle}${suffix}`;
    }
  }, [pageTitle, settings?.siteName, settings?.pageTabTitles?.blog, settings?.pageTabTitles?.titleSuffix]);

  const catBg = settings?.theme?.categoryPageBgColor || 'var(--category-page-bg, #F8FAFC)';

  return (
    <div id="blog-catalog-page" className="py-6 min-h-screen" style={{ backgroundColor: catBg }}>
      <ArticleGrid
        badge={articleSec?.badge !== undefined && articleSec.badge.trim() !== '' ? articleSec.badge : 'ARTIKEL & BERITA HUKUM'}
        title={pageTitle}
        subtitle={articleSec?.subtitle !== undefined && articleSec.subtitle.trim() !== '' ? articleSec.subtitle : 'Kumpulan analisis hukum, opini, konsultasi, dan wawasan peradilan oleh Aly Yusuf Law Firm & Partner.'}
        showSidebar={true}
        limit={18}
        isPageMode={true}
      />
    </div>
  );
}
